export const FOCUS = Object.freeze({
  NONE: 'NONE',
  START_DATE: 'START_DATE',
  END_DATE: 'END_DATE',
});
